<div class="home-container">
  <div class="update-container">
    <div class="title-update">
      <h2>
        Updates
      </h2>
    </div>
    <div class="update-items-container">
      <ul>
        <li>
          Anime Search
        </li>
        <li>
          Anime Details Page
        </li>
        <li>
          Anime Randomizer
        </li>
        <li>
          TOP 100 Animes
        </li>
        <li>
          Mobile ui Friendly
        </li>
      </ul>
    </div>
  </div>

  <div class="backlog-container">
    <div class="title-backlog">
      <h2>
        Coming Soon...
      </h2>
    </div>
    <div class="backlog-items-container">
      <ul>
        <li>
          Change Home page to top seasonal animes
        </li>
      </ul>
    </div>
  </div>
</div>